import React from 'react';
import { Link } from 'react-router-dom';
import { Languages } from 'lucide-react';
import { BLOG_CFG } from '../data/blogConfig';
import { PILLARS } from '../data/editorial';

export default function Blogs({ lang = 'en' }) {
  const c = BLOG_CFG[lang];
  const POSTS = c.posts;
  return (
    <div className="max-w-[1100px] mx-auto px-5 py-12" data-testid={`blogs-page-${lang}`}>
      {(c.heading || lang === 'en') && (
        <div className="text-center mb-10 fade-up">
          <h1 className="font-hand text-[34px] md:text-[40px] text-slate-900" data-testid="blog-heading">{c.heading || 'Cursive text guides'}</h1>
          <p className="text-[15px] text-slate-600 mt-2 max-w-[620px] mx-auto">{c.sub}</p>
        </div>
      )}
      {lang === 'fr' && <nav aria-label="Thèmes du blog" className="flex flex-wrap justify-center gap-3 mb-8">{PILLARS.map(p => <Link className="pill-btn" to={p.path} key={p.id}>{p.title}</Link>)}</nav>}
      <div className="flex justify-end mb-5">
        <Link to={c.switchTo} className="inline-flex items-center gap-1.5 text-[13.5px] text-[var(--brand)] hover:underline" data-testid="blog-lang-switch"><Languages className="w-4 h-4" />{c.switchLabel}</Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {POSTS.map((p, i) => (
          <article key={p.slug} className="blog-card group fade-up" style={{ animationDelay: `${i * 60}ms` }} data-testid={`blog-card-${p.slug}`}>
            <Link to={`${c.base}/${p.slug}`} className="block overflow-hidden aspect-[3/2]">
              <img src={p.img} alt={p.imgAlt} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </Link>
            <div className="p-6">
              <span className="text-[13px] text-[var(--brand)]">{p.cat}</span>
              <h2 className="text-[20px] font-bold leading-snug text-[var(--ink)] mt-1.5 mb-2">
                <Link to={`${c.base}/${p.slug}`} className="hover:text-[var(--brand)] transition-colors">{p.title}</Link>
              </h2>
              <p className="text-[14.5px] text-slate-600 leading-relaxed">{p.excerpt}</p>
              <Link to={`${c.base}/${p.slug}`} className="inline-block mt-3 text-[14px] font-medium text-[var(--brand)] hover:underline">{c.readMore}</Link>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
